import React from 'react';

export const DropdownGroup = ({
  title,
  children,
}: {
  title: React.ReactNode;
  children?: React.ReactNode;
}) => {
  return (
    <div role="group">
      <div className="px-3 py-2">{title}</div>
      {children}
    </div>
  );
};
